"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalScroll = void 0;

var _theming = require("@storybook/theming");

var HorizontalScroll = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1wgulgz0"
} : {
  target: "e1wgulgz0",
  label: "HorizontalScroll"
})("display:flex;gap:", function (props) {
  return props.gap;
}, ";scroll-padding:", function (props) {
  return props.scrollPadding;
}, ";overflow-x:scroll;scroll-snap-type:x mandatory;&>*{flex:none;scroll-snap-align:start;}");
exports.HorizontalScroll = HorizontalScroll;
HorizontalScroll.defaultProps = {
  gap: '2rem',
  scrollPadding: '0'
};